<template>
  <div class="flex flex-col items-end mt-1 w-full mx-auto">
    <section class="bg-gray-300 p-6 w-full rounded" :aria-label="$t('stripe.data')">
      <input class="w-full py-2 pl-2 outline-none rounded" :placeholder="$t('stripe.holder')"
      v-model="cardHolder" />
      <div class="bg-white mt-4 rounded p-3" id="card-element" ref="card"></div>

      <div class="flex justify-center mt-8">
        <button id="card-button" class="rounded bg-white py-2 px-4 mt-5
          hover:text-white hover:bg-gray-600 transform text-sm
          hover:scale-105 shadow-lg"
        @click="savePaymentMethod()" :class="isLoading ? 'loader' : ''">
          {{ $t('stripe.save') }}
        </button>
      </div>

    </section>

  </div>

</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { getStudentSetupIntent } from '@/services/PaymentService';

// eslint-disable-next-line no-undef
const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
let card = null;

export default {
  data() {
    return {
      cardHolder: '',

      isLoading: false,
    };
  },

  mounted() {
    this.displayCard();
  },

  beforeDestroy() {
    card.destroy(this.$refs.card);
  },

  computed: {
    ...mapGetters({
      student: ['auth/student'],
    }),

  },

  methods: {
    displayCard() {
      const elements = stripe.elements({
        locale: this.$i18n.locale,
      });
      card = elements.create('card');

      card.mount(this.$refs.card);
    },

    savePaymentMethod() {
      this.isLoading = true;
      getStudentSetupIntent(this.student.id).then(({ data }) => {
        stripe.confirmCardSetup(
          data.client_secret, {
            payment_method: {
              card,
              billing_details: { name: this.cardHolder },
            },
          },
        ).then((result) => {
          if (result.error) {
            this.isLoading = false;
            this.createNotification('error', result.error.message);
            return;
          }
          axios.post(`/api/students/${this.student.id}/update-payment-method`, { stripe_id: result.setupIntent.payment_method, type: 'card' }).then(() => {
            this.$emit('updated-payment-method');
            this.isLoading = false;
          }).catch((error) => {
            this.isLoading = false;
            this.checkSessionErrorNotification(error);
          });
        });
      });
    },
  },

};
</script>
